// extracted by mini-css-extract-plugin
export default {"itens":"Itens_itens__UZ2qb"};